import { render, staticRenderFns } from "./MyProjectsWidget.vue?vue&type=template&id=ea1b4eca&"
import script from "./MyProjectsWidget.vue?vue&type=script&lang=js&"
export * from "./MyProjectsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports